import { render, staticRenderFns } from "./tableInvoice.vue?vue&type=template&id=5533cda8&scoped=true&slot-scope=scope&"
import script from "./tableInvoice.vue?vue&type=script&lang=js&"
export * from "./tableInvoice.vue?vue&type=script&lang=js&"
import style0 from "./tableInvoice.vue?vue&type=style&index=0&id=5533cda8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5533cda8",
  null
  
)

export default component.exports